<template>
  <div style="height: 100%;">
    <comm-record :type="type" :deviceId="deviceId"></comm-record>
  </div>
</template>
<script>
import commRecord from './comm-record';
export default {
  name: "temp-record",
 data() {
   return {
   }
 },
 props: ['type','deviceId'],
 components: {
    commRecord
  }
}
</script>



// WEBPACK FOOTER //
// src/components/riskRecord/temp-record.vue